module.exports = __webpack_public_path__ + "img/Tablet - 39.854f42f3.png";